import { render, staticRenderFns } from "./PostLocation.vue?vue&type=template&id=fd30cee4&"
import script from "./PostLocation.vue?vue&type=script&lang=js&"
export * from "./PostLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports